module.exports = __webpack_public_path__ + "static/media/create_outline.b4fd7698.svg";